import { render, staticRenderFns } from "./ReportFolders.vue?vue&type=template&id=c2dd49c4&scoped=true&"
import script from "./ReportFolders.vue?vue&type=script&lang=js&"
export * from "./ReportFolders.vue?vue&type=script&lang=js&"
import style0 from "./ReportFolders.vue?vue&type=style&index=0&id=c2dd49c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd49c4",
  null
  
)

export default component.exports